import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';

const BusinessDirectoryBenefitsLanding = () => {
  const navigate = useNavigate();
  const mockUser = null;

  const heroFeatures = [
    {
      id: 1,
      icon: "Store",
      title: "Directorio Completo",
      description: "Accede a miles de negocios verificados en tu ciudad",
      color: "bg-primary"
    },
    {
      id: 2,
      icon: "Tag",
      title: "Descuentos Exclusivos",
      description: "Ofertas y promociones disponibles solo para usuarios registrados",
      color: "bg-secondary"
    },
    {
      id: 3,
      icon: "Search",
      title: "Búsqueda Inteligente",
      description: "Encuentra productos y servicios por categoría o ubicación",
      color: "bg-accent"
    },
    {
      id: 4,
      icon: "Globe",
      title: "Expansión Internacional",
      description: "Pronto acceso a negocios a nivel nacional e internacional",
      color: "bg-success"
    }
  ];

  const accessLevels = [
    {
      id: 1,
      level: "Acceso Local",
      icon: "MapPin",
      description: "Descubre negocios en tu ciudad",
      features: [
        "Restaurantes con descuentos",
        "Tiendas de retail local",
        "Servicios profesionales",
        "Entretenimiento y ocio",
        "Salud y bienestar"
      ],
      color: "bg-primary",
      textColor: "text-primary-foreground",
      status: "Disponible Ahora",
      badgeColor: "bg-success"
    },
    {
      id: 2,
      level: "Cobertura Nacional",
      icon: "Map",
      description: "Explora oportunidades en toda Colombia",
      features: [
        "Cadenas nacionales",
        "Servicios en línea",
        "E-commerce colombiano",
        "Turismo y viajes",
        "Educación y formación"
      ],
      color: "bg-secondary",
      textColor: "text-secondary-foreground",
      status: "En Expansión",
      badgeColor: "bg-warning"
    },
    {
      id: 3,
      level: "Alcance Internacional",
      icon: "Globe",
      description: "Próximamente: Comercio global",
      features: [
        "Marcas internacionales",
        "Importaciones directas",
        "Servicios digitales globales",
        "Alianzas estratégicas",
        "Comercio electrónico mundial"
      ],
      color: "bg-accent",
      textColor: "text-accent-foreground",
      status: "Próximamente",
      badgeColor: "bg-muted"
    }
  ];

  const discountCategories = [
    {
      id: 1,
      category: "Restaurantes",
      icon: "Utensils",
      averageDiscount: "15-30%",
      examples: ["Comida rápida", "Restaurantes gourmet", "Cafeterías", "Delivery"],
      image: "/assets/images/restaurantes_category.png",
      businessCount: "200+"
    },
    {
      id: 2,
      category: "Retail",
      icon: "ShoppingBag",
      averageDiscount: "10-25%",
      examples: ["Ropa y accesorios", "Tecnología", "Hogar", "Deportes"],
      image: "/assets/images/retail_category.png",
      businessCount: "350+"
    },
    {
      id: 3,
      category: "Servicios",
      icon: "Briefcase",
      averageDiscount: "20-40%",
      examples: ["Belleza", "Salud", "Educación", "Profesionales"],
      image: "/assets/images/servicios_category.png",
      businessCount: "180+"
    },
    {
      id: 4,
      category: "Entretenimiento",
      icon: "Music",
      averageDiscount: "15-35%",
      examples: ["Cine", "Eventos", "Gimnasios", "Turismo"],
      image: "/assets/images/entretenimiento_category.png",
      businessCount: "120+"
    }
  ];

  const geographicExpansion = [
    {
      id: 1,
      phase: "Fase Actual",
      location: "Pasto, Nariño",
      businesses: "850+ empresas",
      icon: "MapPin",
      status: "active",
      color: "bg-success"
    },
    {
      id: 2,
      phase: "Expansión 2025",
      location: "Principales ciudades de Colombia",
      businesses: "5.000+ empresas proyectadas",
      icon: "Map",
      status: "planned",
      color: "bg-warning"
    },
    {
      id: 3,
      phase: "Visión 2026",
      location: "América Latina",
      businesses: "20.000+ empresas objetivo",
      icon: "Globe",
      status: "future",
      color: "bg-muted"
    }
  ];

  const userTestimonials = [
    {
      id: 1,
      name: "Andrea Martínez",
      role: "Usuario Emprendedor desde Enero 2024",
      testimonial: "He ahorrado más de $800.000 en 6 meses usando los descuentos del directorio. Encuentro ofertas increíbles en restaurantes y tiendas cercanas a mi casa.",
      savings: "$800.000 ahorrados",
      favoriteCategory: "Restaurantes",
      image: "/assets/images/no_image.png"
    },
    {
      id: 2,
      name: "Felipe Castro",
      role: "Usuario Elite desde Marzo 2024",
      testimonial: "El directorio me permite descubrir nuevos negocios locales constantemente. Los descuentos en servicios profesionales han sido especialmente útiles.",
      savings: "$1.200.000 ahorrados",
      favoriteCategory: "Servicios Profesionales",
      image: "/assets/images/no_image.png"
    }
  ];

  const directoryFeatures = [
    {
      id: 1,
      feature: "Búsqueda por Categoría",
      description: "Filtra negocios por tipo: restaurantes, retail, servicios, entretenimiento y más",
      icon: "Filter"
    },
    {
      id: 2,
      feature: "Ubicación Inteligente",
      description: "Encuentra negocios cercanos a tu ubicación actual o en áreas específicas",
      icon: "Navigation"
    },
    {
      id: 3,
      feature: "Perfiles Completos",
      description: "Información detallada: horarios, contacto, fotos, descuentos disponibles",
      icon: "FileText"
    },
    {
      id: 4,
      feature: "Código QR Exclusivo",
      description: "Escanea códigos QR en negocios para acceder a promociones instantáneas",
      icon: "QrCode"
    },
    {
      id: 5,
      feature: "Sistema de Reseñas",
      description: "Lee opiniones de otros usuarios y comparte tu experiencia",
      icon: "Star"
    },
    {
      id: 6,
      feature: "Notificaciones Personalizadas",
      description: "Recibe alertas de nuevos descuentos en tus categorías favoritas",
      icon: "Bell"
    }
  ];

  const savingsCalculator = [
    {
      id: 1,
      scenario: "Usuario Básico",
      monthlySpending: "$1.000.000",
      averageSavings: "15%",
      monthlySavings: "$150.000",
      annualSavings: "$1.800.000",
      icon: "User"
    },
    {
      id: 2,
      scenario: "Usuario Emprendedor",
      monthlySpending: "$2.000.000",
      averageSavings: "20%",
      monthlySavings: "$400.000",
      annualSavings: "$4.800.000",
      icon: "TrendingUp"
    },
    {
      id: 3,
      scenario: "Usuario Elite",
      monthlySpending: "$3.000.000",
      averageSavings: "25%",
      monthlySavings: "$750.000",
      annualSavings: "$9.000.000",
      icon: "Award"
    }
  ];

  const comparisonPoints = [
    {
      id: 1,
      traditional: "Búsqueda manual de ofertas",
      bizznet: "Directorio centralizado con todas las ofertas",
      icon: "Search",
      advantage: "Ahorra tiempo"
    },
    {
      id: 2,
      traditional: "Descuentos limitados y esporádicos",
      bizznet: "Acceso exclusivo a descuentos permanentes",
      icon: "Tag",
      advantage: "Más ahorro"
    },
    {
      id: 3,
      traditional: "Información desactualizada",
      bizznet: "Perfiles verificados y actualizados",
      icon: "CheckCircle",
      advantage: "Confiabilidad"
    },
    {
      id: 4,
      traditional: "Sin seguimiento de ahorro",
      bizznet: "Panel de ahorro personalizado",
      icon: "BarChart",
      advantage: "Control total"
    }
  ];

  const exclusiveAccess = [
    {
      id: 1,
      benefit: "Solo para Usuarios Registrados",
      description: "El directorio empresarial es un beneficio exclusivo de tu membresía Bizznet",
      icon: "Lock"
    },
    {
      id: 2,
      benefit: "Actualización Constante",
      description: "Nuevos negocios y ofertas se agregan semanalmente al directorio",
      icon: "RefreshCw"
    },
    {
      id: 3,
      benefit: "Soporte Prioritario",
      description: "Asistencia dedicada para ayudarte a encontrar lo que necesitas",
      icon: "Headphones"
    }
  ];

  const upcomingFeatures = [
    {
      id: 1,
      feature: "Reservas en Línea",
      description: "Próximamente: reserva directamente desde la app",
      icon: "Calendar",
      timeline: "Q2 2025"
    },
    {
      id: 2,
      feature: "Programa de Lealtad",
      description: "Acumula puntos adicionales por compras en negocios del directorio",
      icon: "Gift",
      timeline: "Q3 2025"
    },
    {
      id: 3,
      feature: "Chatbot AI",
      description: "Asistente virtual para recomendaciones personalizadas",
      icon: "MessageSquare",
      timeline: "Q4 2025"
    }
  ];

  const faqs = [
    {
      id: 1,
      question: "¿Cómo accedo al Directorio Empresarial?",
      answer: "El directorio está disponible exclusivamente para usuarios registrados con plan Emprendedor o Elite. Una vez registrado, puedes acceder desde tu dashboard o desde el menú principal."
    },
    {
      id: 2,
      question: "¿Los descuentos son aplicables inmediatamente?",
      answer: "Sí, una vez que escaneas el código QR del negocio o presentas tu código de usuario, los descuentos se aplican de inmediato en el establecimiento."
    },
    {
      id: 3,
      question: "¿Puedo sugerir negocios para el directorio?",
      answer: "¡Por supuesto! Valoramos tus recomendaciones. Puedes enviar sugerencias desde tu perfil y nuestro equipo evaluará la inclusión del negocio."
    },
    {
      id: 4,
      question: "¿Los negocios del directorio están verificados?",
      answer: "Sí, todos los negocios del directorio pasan por un proceso de verificación para garantizar su legitimidad y la validez de sus ofertas."
    }
  ];

  return (
    <div className="min-h-screen bg-background">
      <Header user={mockUser} />
      
      <main>
        {/* Hero Section */}
        <section className="relative py-16 md:py-20 lg:py-24 px-4 sm:px-6 bg-gradient-to-br from-primary via-primary/90 to-secondary text-white overflow-hidden">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute inset-0" style={{
              backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
              backgroundSize: '40px 40px'
            }} />
          </div>
          
          <div className="max-w-7xl mx-auto relative z-10">
            <div className="text-center mb-12">
              <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-bold mb-6">
                <Icon name="Store" size={20} />
                <span>DIRECTORIO EMPRESARIAL BIZZNET</span>
              </div>
              
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-6 px-4">
                Tu Puerta de Acceso a Miles de Negocios y Descuentos Exclusivos
              </h1>
              
              <p className="text-lg sm:text-xl md:text-2xl opacity-90 mb-8 max-w-3xl mx-auto px-4">
                Explora el directorio empresarial más completo de Colombia. Encuentra productos, servicios, descuentos y promociones exclusivas en tu ciudad y pronto a nivel nacional e internacional.
              </p>
              
              <div className="flex justify-center items-center">
                <Button
                  variant="outline"
                  size="lg"
                  iconName="UserPlus"
                  iconPosition="left"
                  onClick={() => navigate('/user-registration')}
                  className="border-white text-white hover:bg-white/10 min-w-[200px]"
                >
                  Registrarse Ahora
                </Button>
              </div>
            </div>

            {/* Hero Features Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-16">
              {heroFeatures?.map((feature) => (
                <div
                  key={feature?.id}
                  className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20"
                >
                  <div className={`w-12 h-12 ${feature?.color} rounded-lg flex items-center justify-center mb-4`}>
                    <Icon name={feature?.icon} size={24} className="text-white" />
                  </div>
                  <h3 className="text-lg font-bold mb-2">{feature?.title}</h3>
                  <p className="text-sm opacity-80">{feature?.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Three-Tier Access System */}
        <section className="py-12 md:py-16 lg:py-20 px-4 sm:px-6 bg-background">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
                Sistema de Acceso de Tres Niveles
              </h2>
              <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
                Desde tu ciudad hasta el mundo: descubre oportunidades de negocio sin límites
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {accessLevels?.map((level) => (
                <div
                  key={level?.id}
                  className={`${level?.color} ${level?.textColor} rounded-2xl p-8 shadow-xl relative overflow-hidden`}
                >
                  <div className={`absolute top-4 right-4 ${level?.badgeColor} text-white text-xs font-bold px-3 py-1 rounded-full`}>
                    {level?.status}
                  </div>

                  <div className="w-16 h-16 bg-white/20 rounded-xl flex items-center justify-center mb-6">
                    <Icon name={level?.icon} size={32} />
                  </div>

                  <h3 className="text-2xl font-bold mb-2">{level?.level}</h3>
                  <p className="text-sm opacity-90 mb-6">{level?.description}</p>

                  <ul className="space-y-3">
                    {level?.features?.map((feature, idx) => (
                      <li key={idx} className="flex items-start gap-2">
                        <Icon name="CheckCircle" size={18} className="flex-shrink-0 mt-0.5" />
                        <span className="text-sm">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Discount Categories Showcase */}
        <section className="py-12 md:py-16 lg:py-20 px-4 sm:px-6 bg-muted">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
                Descuentos en Todas las Categorías
              </h2>
              <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
                Ahorra en los productos y servicios que más utilizas
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {discountCategories?.map((category) => (
                <div
                  key={category?.id}
                  className="bg-card rounded-xl overflow-hidden shadow-card hover:shadow-lg transition-shadow"
                >
                  <div className="relative h-48 bg-muted">
                    <img
                      src={category?.image}
                      alt={`Imagen representativa de la categoría ${category?.category} mostrando negocios y descuentos disponibles en BIZZNET`}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute top-4 right-4 bg-success text-white text-xs font-bold px-3 py-1 rounded-full">
                      {category?.businessCount}
                    </div>
                  </div>

                  <div className="p-6">
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-10 h-10 bg-primary/10 text-primary rounded-lg flex items-center justify-center">
                        <Icon name={category?.icon} size={20} />
                      </div>
                      <h3 className="text-lg font-bold">{category?.category}</h3>
                    </div>

                    <div className="mb-4">
                      <div className="text-2xl font-bold text-primary mb-1">
                        {category?.averageDiscount}
                      </div>
                      <div className="text-xs text-muted-foreground">Descuento promedio</div>
                    </div>

                    <div className="space-y-2">
                      {category?.examples?.map((example, idx) => (
                        <div key={idx} className="flex items-center gap-2">
                          <div className="w-1.5 h-1.5 bg-primary rounded-full" />
                          <span className="text-sm text-muted-foreground">{example}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Geographic Expansion Visualization */}
        <section className="py-12 md:py-16 lg:py-20 px-4 sm:px-6 bg-background">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
                Expansión Geográfica
              </h2>
              <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
                De local a global: nuestra hoja de ruta de crecimiento
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {geographicExpansion?.map((phase) => (
                <div
                  key={phase?.id}
                  className="bg-card rounded-xl p-8 shadow-card relative"
                >
                  <div className={`w-16 h-16 ${phase?.color} rounded-full flex items-center justify-center mx-auto mb-6`}>
                    <Icon name={phase?.icon} size={32} className="text-white" />
                  </div>

                  <h3 className="text-xl font-bold text-center mb-2">{phase?.phase}</h3>
                  <p className="text-primary font-bold text-center mb-1">{phase?.location}</p>
                  <p className="text-sm text-muted-foreground text-center mb-6">{phase?.businesses}</p>

                  {phase?.status === 'active' && (
                    <div className="text-center">
                      <span className="inline-flex items-center gap-2 bg-success/10 text-success text-sm font-bold px-4 py-2 rounded-full">
                        <Icon name="CheckCircle" size={16} />
                        Activo Ahora
                      </span>
                    </div>
                  )}

                  {phase?.status === 'planned' && (
                    <div className="text-center">
                      <span className="inline-flex items-center gap-2 bg-warning/10 text-warning text-sm font-bold px-4 py-2 rounded-full">
                        <Icon name="TrendingUp" size={16} />
                        En Desarrollo
                      </span>
                    </div>
                  )}

                  {phase?.status === 'future' && (
                    <div className="text-center">
                      <span className="inline-flex items-center gap-2 bg-muted text-muted-foreground text-sm font-bold px-4 py-2 rounded-full">
                        <Icon name="Target" size={16} />
                        Próximamente
                      </span>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* User Testimonials */}
        <section className="py-12 md:py-16 lg:py-20 px-4 sm:px-6 bg-muted">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
                Historias de Ahorro Real
              </h2>
              <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
                Descubre cómo otros usuarios aprovechan el directorio empresarial
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {userTestimonials?.map((testimonial) => (
                <div
                  key={testimonial?.id}
                  className="bg-card rounded-xl p-6 md:p-8 shadow-card"
                >
                  <div className="flex items-start gap-4 mb-6">
                    <img
                      src={testimonial?.image}
                      alt={`Foto de perfil de ${testimonial?.name}, usuario satisfecho del directorio empresarial de BIZZNET`}
                      className="w-16 h-16 rounded-full object-cover"
                    />
                    <div>
                      <h3 className="font-bold text-lg">{testimonial?.name}</h3>
                      <p className="text-sm text-muted-foreground">{testimonial?.role}</p>
                    </div>
                  </div>

                  <p className="text-muted-foreground mb-6 italic">
                    "{testimonial?.testimonial}"
                  </p>

                  <div className="flex flex-wrap gap-4 pt-4 border-t border-border">
                    <div className="flex items-center gap-2">
                      <Icon name="DollarSign" size={18} className="text-success" />
                      <span className="text-sm font-semibold">{testimonial?.savings}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <Icon name="Heart" size={18} className="text-primary" />
                      <span className="text-sm font-semibold">{testimonial?.favoriteCategory}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Directory Features */}
        <section className="py-12 md:py-16 lg:py-20 px-4 sm:px-6 bg-background">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
                Características del Directorio
              </h2>
              <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
                Herramientas inteligentes para encontrar exactamente lo que necesitas
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {directoryFeatures?.map((feature) => (
                <div
                  key={feature?.id}
                  className="bg-card rounded-xl p-6 shadow-card hover:shadow-lg transition-shadow"
                >
                  <div className="w-12 h-12 bg-primary/10 text-primary rounded-lg flex items-center justify-center mb-4">
                    <Icon name={feature?.icon} size={24} />
                  </div>
                  <h3 className="text-lg font-bold mb-2">{feature?.feature}</h3>
                  <p className="text-sm text-muted-foreground">{feature?.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Savings Calculator */}
        <section className="py-12 md:py-16 lg:py-20 px-4 sm:px-6 bg-muted">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
                Calculadora de Ahorro Anual
              </h2>
              <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
                Estima cuánto podrías ahorrar usando el directorio empresarial
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {savingsCalculator?.map((scenario) => (
                <div
                  key={scenario?.id}
                  className="bg-card rounded-xl p-6 shadow-card"
                >
                  <div className="flex items-center justify-center w-12 h-12 bg-primary text-primary-foreground rounded-lg mx-auto mb-4">
                    <Icon name={scenario?.icon} size={24} />
                  </div>

                  <h3 className="text-xl font-bold text-center mb-4">{scenario?.scenario}</h3>

                  <div className="space-y-4">
                    <div className="bg-muted rounded-lg p-4">
                      <div className="text-sm text-muted-foreground mb-1">Gasto mensual</div>
                      <div className="text-lg font-bold">{scenario?.monthlySpending}</div>
                    </div>

                    <div className="bg-muted rounded-lg p-4">
                      <div className="text-sm text-muted-foreground mb-1">Ahorro promedio</div>
                      <div className="text-lg font-bold text-primary">{scenario?.averageSavings}</div>
                    </div>

                    <div className="bg-muted rounded-lg p-4">
                      <div className="text-sm text-muted-foreground mb-1">Ahorro mensual</div>
                      <div className="text-lg font-bold text-success">{scenario?.monthlySavings}</div>
                    </div>

                    <div className="bg-gradient-to-r from-primary to-secondary text-white rounded-lg p-4">
                      <div className="text-sm opacity-90 mb-1">Ahorro anual estimado</div>
                      <div className="text-2xl font-bold">{scenario?.annualSavings}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-8 text-center">
              <p className="text-sm text-muted-foreground max-w-2xl mx-auto">
                *Los cálculos son estimados basados en el uso promedio del directorio. 
                Tu ahorro real dependerá de tus hábitos de consumo y los negocios que visites.
              </p>
            </div>
          </div>
        </section>

        {/* Comparison Table */}
        <section className="py-12 md:py-16 lg:py-20 px-4 sm:px-6 bg-background">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
                Directorio BIZZNET vs Búsqueda Tradicional
              </h2>
              <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
                La diferencia es clara: ahorra tiempo y dinero
              </p>
            </div>

            <div className="bg-card rounded-2xl shadow-card overflow-hidden">
              <div className="grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-border">
                <div className="p-6 bg-muted/50">
                  <h3 className="text-lg font-bold text-center mb-4">Método Tradicional</h3>
                </div>
                <div className="p-6 bg-primary/5">
                  <h3 className="text-lg font-bold text-center mb-4 text-primary">Directorio BIZZNET</h3>
                </div>
                <div className="p-6 bg-success/5">
                  <h3 className="text-lg font-bold text-center mb-4 text-success">Ventaja</h3>
                </div>
              </div>

              {comparisonPoints?.map((point) => (
                <div
                  key={point?.id}
                  className="grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-border border-t border-border"
                >
                  <div className="p-6 flex items-center gap-3">
                    <Icon name="X" size={20} className="text-destructive flex-shrink-0" />
                    <span className="text-sm">{point?.traditional}</span>
                  </div>
                  <div className="p-6 flex items-center gap-3 bg-primary/5">
                    <Icon name="Check" size={20} className="text-primary flex-shrink-0" />
                    <span className="text-sm font-medium">{point?.bizznet}</span>
                  </div>
                  <div className="p-6 flex items-center gap-3 bg-success/5">
                    <Icon name={point?.icon} size={20} className="text-success flex-shrink-0" />
                    <span className="text-sm font-bold text-success">{point?.advantage}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Exclusive Access Notice */}
        <section className="py-12 md:py-16 lg:py-20 px-4 sm:px-6 bg-gradient-to-r from-primary to-secondary text-white">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <Icon name="Lock" size={48} className="mx-auto mb-6" />
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
                Acceso Exclusivo para Usuarios Registrados
              </h2>
              <p className="text-lg opacity-90 max-w-3xl mx-auto">
                El directorio empresarial es un beneficio exclusivo de tu membresía BIZZNET
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {exclusiveAccess?.map((item) => (
                <div
                  key={item?.id}
                  className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20"
                >
                  <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center mb-4">
                    <Icon name={item?.icon} size={24} />
                  </div>
                  <h3 className="text-lg font-bold mb-2">{item?.benefit}</h3>
                  <p className="text-sm opacity-80">{item?.description}</p>
                </div>
              ))}
            </div>

            <div className="mt-12 text-center">
              <Button
                variant="default"
                size="lg"
                iconName="UserPlus"
                iconPosition="left"
                onClick={() => navigate('/user-registration')}
                className="bg-white text-primary hover:bg-white/90 min-w-[250px]"
              >
                Registrarse para Acceder
              </Button>
            </div>
          </div>
        </section>

        {/* Upcoming Features */}
        <section className="py-12 md:py-16 lg:py-20 px-4 sm:px-6 bg-muted">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
                Próximas Funcionalidades
              </h2>
              <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
                Mejoras continuas para optimizar tu experiencia
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {upcomingFeatures?.map((feature) => (
                <div
                  key={feature?.id}
                  className="bg-card rounded-xl p-6 shadow-card relative overflow-hidden"
                >
                  <div className="absolute top-4 right-4 bg-accent text-white text-xs font-bold px-3 py-1 rounded-full">
                    {feature?.timeline}
                  </div>

                  <div className="w-12 h-12 bg-accent/10 text-accent rounded-lg flex items-center justify-center mb-4">
                    <Icon name={feature?.icon} size={24} />
                  </div>

                  <h3 className="text-lg font-bold mb-2">{feature?.feature}</h3>
                  <p className="text-sm text-muted-foreground">{feature?.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQs */}
        <section className="py-12 md:py-16 lg:py-20 px-4 sm:px-6 bg-background">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
                Preguntas Frecuentes
              </h2>
              <p className="text-lg text-muted-foreground">
                Todo lo que necesitas saber sobre el Directorio Empresarial
              </p>
            </div>

            <div className="space-y-4">
              {faqs?.map((faq) => (
                <div
                  key={faq?.id}
                  className="bg-card rounded-xl p-6 shadow-card"
                >
                  <div className="flex items-start gap-3 mb-3">
                    <Icon name="HelpCircle" size={20} className="text-primary flex-shrink-0 mt-1" />
                    <h3 className="font-bold text-lg">{faq?.question}</h3>
                  </div>
                  <p className="text-muted-foreground text-sm pl-8">
                    {faq?.answer}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Final CTA */}
        <section className="py-12 md:py-16 lg:py-20 px-4 sm:px-6 bg-gradient-to-r from-primary to-secondary text-white">
          <div className="max-w-4xl mx-auto text-center">
            <Icon name="Sparkles" size={48} className="mx-auto mb-6" />
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6">
              Descubre Miles de Oportunidades de Ahorro
            </h2>
            <p className="text-lg md:text-xl opacity-90 mb-8 max-w-2xl mx-auto">
              Únete a BIZZNET hoy y obtén acceso instantáneo al directorio empresarial más completo de Colombia. 
              Ahorra en tus compras diarias mientras apoyas negocios locales.
            </p>
            
            <div className="flex justify-center">
              <Button
                variant="outline"
                size="lg"
                iconName="UserPlus"
                iconPosition="left"
                onClick={() => navigate('/user-registration')}
                className="border-white text-white hover:bg-white/10 min-w-[220px]"
              >
                Regístrate ahora
              </Button>
            </div>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-3xl mx-auto">
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4">
                <div className="text-2xl font-bold mb-1">850+</div>
                <div className="text-sm opacity-80">Negocios Activos</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4">
                <div className="text-2xl font-bold mb-1">15-30%</div>
                <div className="text-sm opacity-80">Descuento Promedio</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4">
                <div className="text-2xl font-bold mb-1">24/7</div>
                <div className="text-sm opacity-80">Acceso Sin Límites</div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <footer className="bg-card border-t border-border py-6 px-4">
        <div className="max-w-7xl mx-auto text-center">
          <p className="text-sm text-muted-foreground">
            © 2024 BIZZNET. Todos los derechos reservados. | 
            <a href="/terms-and-conditions" className="hover:text-primary ml-2">Términos</a> | 
            <a href="/privacy-policy" className="hover:text-primary ml-2">Privacidad</a>
          </p>
        </div>
      </footer>
    </div>
  );
};

export default BusinessDirectoryBenefitsLanding;